import * as React from "react";
const RealTimeSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#040919"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#040919"
      strokeOpacity={0.03}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#040919"
      d="M39.375 28.946a11.388 11.388 0 1 1-12.322-12.322.878.878 0 1 1 .144 1.75 9.638 9.638 0 1 0 10.428 10.428.878.878 0 1 1 1.75.144Zm-12.25-7.072V28a.875.875 0 0 0 .875.875h6.125a.875.875 0 0 0 0-1.75h-5.25v-5.25a.875.875 0 1 0-1.75 0ZM31.5 19.25a1.313 1.313 0 1 0 0-2.626 1.313 1.313 0 0 0 0 2.626Zm3.938 2.625a1.313 1.313 0 1 0 0-2.626 1.313 1.313 0 0 0 0 2.626Zm2.624 3.938a1.313 1.313 0 1 0 0-2.626 1.313 1.313 0 0 0 0 2.626Z"
    />
  </svg>
);
export default RealTimeSVG;
